export type PaymentStatusDisplayOptions = {
  bookedBy?: string | null
}

export const getPaymentStatusDisplay = (
  paymentStatus: string | null | undefined,
  options: PaymentStatusDisplayOptions = {}
) => {
  const addedByYou = options.bookedBy === "pro"
  const suffix = addedByYou ? " · Added by you" : ""

  switch (paymentStatus) {
    case "free":
      return { label: `Free${suffix}`, color: "text-green" }
    case "paid":
      return { label: `Paid${suffix}`, color: "text-green" }
    case "upcoming":
      return { label: `Upcoming${suffix}`, color: "text-orange" }
    case "unpaid":
      return { label: `Payment Pending${suffix}`, color: "text-orange" }
    case "failed":
      return { label: `Payment Failed${suffix}`, color: "text-red" }
    default:
      return { label: `No Payment Required${suffix}`, color: "text-gray-dark" }
  }
}

export type RegistrationPaymentFields = {
  amountCents?: number | null
  markPaid?: boolean | null
  paymentStatus?: string | null
}

export const canProcessRegistrationPayment = (registration: RegistrationPaymentFields | null | undefined) => {
  if (!registration) return false
  if (registration.amountCents === 0) return false
  if (registration.markPaid) return false
  if (registration.paymentStatus === "paid") return false
  return ["unpaid", "failed", "none", "upcoming"].includes(registration.paymentStatus || "")
}

/** Pros can change amount before payment is collected, including Free ($0) regs. */
export const canEditRegistrationPrice = (registration: RegistrationPaymentFields | null | undefined) => {
  if (!registration) return false
  if (registration.markPaid) return false
  if (registration.paymentStatus === "paid") return false
  return ["free", "unpaid", "failed", "none", "upcoming"].includes(registration.paymentStatus || "")
}

export const shouldOpenPostAddPaymentWizard = ({
  registration,
  paymentResult
}: {
  registration?: RegistrationPaymentFields & { id?: string } | null
  paymentResult?: string | null
}) => {
  if (!registration?.id) return false
  if (!registration.amountCents || registration.amountCents <= 0) return false
  if (registration.paymentStatus === "paid" || registration.paymentStatus === "free") return false
  if (paymentResult === "charged" || paymentResult === "scheduled") return false
  return true
}

export const resolvePaymentRequestSendTo = (client?: { email?: string | null; phone?: string | null } | null) => {
  const hasEmail = Boolean(client?.email)
  const hasPhone = Boolean(client?.phone)
  if (hasEmail && hasPhone) return "both"
  if (hasEmail) return "email"
  if (hasPhone) return "sms"
  return null
}
